export interface ExtractedProspect {
  company: string;
  contact_firstname?: string;
  contact_lastname?: string;
  phone?: string;
  email?: string;
  address?: string;
  zip?: string;
  city?: string;
  need?: string;
  notes?: string;
}

/** Appelle l'API d'extraction IA (même logique que l'ancien VoiceProspectButton). */
export async function fetchExtractedProspect(text: string): Promise<ExtractedProspect> {
  const trimmed = text.trim();
  if (!trimmed) {
    return { company: "", notes: "", need: "" };
  }
  try {
    const response = await fetch("/api/ai/extract-prospect", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ text: trimmed }),
    });
    const data = await response.json();
    if (data.error) {
      console.error("Extraction error:", data.error);
      return { company: "", notes: trimmed, need: trimmed };
    }
    return data as ExtractedProspect;
  } catch (err) {
    console.error("AI extraction error:", err);
    return { company: "", notes: trimmed, need: trimmed };
  }
}
